import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTAButton({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-9">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={() => {
      trackAddToCart();
      window.location.href = 'https://tutiendadigi.shop/cart/51961990480152:1';
    }} className="w-full bg-brand hover:bg-brand-dark text-[#0A0A0A] font-display font-bold md:text-2xl py-5 px-8 rounded uppercase tracking-wider transition-colors shadow-[0_0_20px_rgba(212,160,23,0.15)] text-[18px]" data-id="element-10">
        lo quiero
      </motion.button>
      <div className="flex items-center gap-2 mt-4 text-zinc-500 text-sm text-center" data-id="element-11">
        <ShieldCheck size={16} className="shrink-0" data-id="element-12" />
        <span data-id="element-13">
          Pago seguro y discreto. No aparecerá el nombre del producto en tu
          resumen de tarjeta.
        </span>
      </div>
    </div>;
}